module.exports = __webpack_public_path__ + "assets/img/travel-day18.3069f50a.png";